import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export const unconfirmedBooking = {
  namespaced: true,
  state: {
    isUnConfirmedUpdate: false,
    booking: '',
    bookingForm: '',
    isReturnBooking: false,
    bookingChangelog: '',
    offerPublicly: true
  },
  getters,
  mutations,
  actions
}
